export default "<div class=\"banner\">\r\n    <span>{{ adminUsername | titlecase }} · You are logged in as an administrator</span>\r\n</div>\r\n"